<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='科秘书管理' label2="设置科室查看范围" url="/person/sectionsecretary/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">姓名：</label>
            <div class="col-xl-2">
              <el-form-item prop="realname">
                <el-input v-model="form.realname" :disabled="true"></el-input>
              </el-form-item>
            </div>
            <label class="col-xl-1 col-form-label">管理单元：</label>
            <div class="col-xl-2">
              <el-form-item prop="section">
                <el-input v-model="form.section" :disabled="true"></el-input>
              </el-form-item>
            </div>
            <label class="col-xl-1 col-form-label">工号：</label>
            <div class="col-xl-2">
              <el-form-item prop="cardno">
                <el-input v-model="form.cardno" :disabled="true"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label">管理单元范围：</label>
            <div class="col-xl-3">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-form-label"></label>
            <div class="col-xl-9">
              <el-tree v-loading="loading" :data="treedata" ref="tree" :filter-node-method="filterNode"
                default-expand-all show-checkbox node-key="id">
              </el-tree>
            </div>
          </div>
          <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
            <div class="m-form__actions m-form__actions--solid">
              <div class="row">
                <div class="col-lg-12 m--align-center">
                  <el-button type="success" icon="el-icon-s-order" @click="Save">保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SetRange',
    data() {
      return {
        form: {
          id: '',
          realname: '',
          cardno: '',
          section: '',
          checkKeys: ''
        },
        treedata: null,
        fullscreenLoading: false,
        filterText: '',
        loading: true
      }
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    methods: {
      Save: function() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true
            this.form.checkKeys = this.$refs.tree.getCheckedKeys()
            this.$http.post(this.$utils.Url.zpgl + '/api/APISecretary/Update', this.form)
              .then(res => {
                console.log(res.data)
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  this.$router.push('/main/person/sectionsecretary/list')
                } else {
                  this.$message({
                    message: res.data.Msg + '，' + res.data.Error,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      LoadSecretary: function() {
        var args = {
          id: this.form.id,
          token: this.form.token
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APISecretary/ViewInfo', args, function(data, model) {
          model.realname = data.Data.SecretaryName
          model.cardno = data.Data.SecretaryNo
          model.section = data.Data.SectionName
          model.checkKeys = data.Data.SecRange
          that.LoadManageSecTree()
        }, null, null, this.form)
      },
      LoadManageSecTree: function() {
        var args = {
          token: this.form.token
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionTree', args, function(data, model) {
          that.treedata = JSON.parse(data.Data)
          if (model.checkKeys !== '' && model.checkKeys !== null) {
            that.$refs.tree.setCheckedKeys(JSON.parse(model.checkKeys))
          }
          that.loading = false
        }, null, null, this.form)
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.id = this.$route.params.id
      this.LoadSecretary()
    }
  }
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }

  .el-select {
    width: 100%;
  }
  
  /deep/.el-tree-node__label {
      font-size: 14px;
      margin-bottom: .5rem;
  }
</style>
